// extracted by mini-css-extract-plugin
module.exports = {"buyerContainer":"styles_buyerContainer__Ma4d8","continueButtonContainer":"styles_continueButtonContainer__5rmKF","errorAlert":"styles_errorAlert__G7jZq"};